import { useEffect, useRef, useState } from "react";
import Sparkle1 from '../assets/sparkle1.png';
import Sparkle2 from '../assets/sparkle2.png';
// import useSound from "use-sound";

import '../styles/ResultEffects.scss';
// import winSound from '../assets/audio/BetRivers_SlotMachine_SmallWin_AAA_20260708.mp3'; // not playing sounds from here for whatever reason.

const SPAWNRATES = {
    'vvv': 5,
    'hhh': 4,
    'bbb': 2
}
const LIMITS = {
    'vvv': 40,
    'hhh': 60,
    'bbb': 100
}
const SIZESTART = {
    'vvv': .5,
    'hhh': .8,
    'bbb': 1
}
const SIZESPREAD = {
    'vvv': 1,
    'hhh': 2,
    'bbb': 3
}

export default function ResultsEffect( {result} ){
    
    const requestRef = useRef();
    const counter = useRef();
    const container = useRef();
    const [ sparkles, setSparkles ] = useState([]);
    const [ spawn, setSpawn ] = useState(null);

    // const [ playSmallWin ] = useSound( winSound, {onload:()=>console.log('sound loaded'),onplay:()=>console.log('sound playing')} );

    useEffect( ()=>{
        setSparkles([]);
        // playSmallWin({forceSoundEnabled:true});
        if (result==='vvv' || result==='hhh' || result==='bbb') {
            console.log('MR SPARKLE!');
            
            
            counter.current = 0;
            requestRef.current = requestAnimationFrame( update );
        }
        return () => cancelAnimationFrame( requestRef.current );
    }, [] );

    const update = () => {
        counter.current += 1;
        // console.log('*',counter.current,SPAWNRATES[result]);
        if (counter.current%SPAWNRATES[result]===0) sparkle();

        requestRef.current = requestAnimationFrame( update );
    }

    const sparkle = () => {
        // console.log('*'+sparkles.length);
        const symb = Math.random()>.3 ? Sparkle2 : Sparkle1;
        const spark = <img src={symb} alt="sparkle" className="sparkle" style={
            {   "--xseed":Math.random(), // x-positiong
                "--sseed":SIZESTART[result]+Math.random()*SIZESPREAD[result], // size
                "--vseed":1+Math.random()*1.5, // velocity
                "--rsseed":Math.random()*90, // rotation start
                "--rvseed":-180+Math.random()*360, // change in rotation
                "--fseed":.5+Math.random()*3 // blur
            }} />;
        setSpawn( spark );
        // setSparkles( [...sparkles,spark] );
    }
    useEffect( ()=>{
        if (spawn && sparkles.length<LIMITS[result]) {
            // console.log('add to',sparkles.length);
            setSparkles( [...sparkles,spawn] );
            setSpawn(null);
        }
    }, [spawn,sparkles] );

    return (
        result==='vvv' || result==='hhh' || result==='bbb'
            ?
            <div className="centered offset sparkle-container" ref={container}>
                {/* <h2>(sparkly effect go here)</h2> */}
                {sparkles.map( s => s )}
            </div>
            :
            <></>
    )
}